export function normalizeAndSplitAssets(loadedAssets, assetDefinitions) {
  const keyMap = {};
  assetDefinitions.forEach(asset => {
    keyMap[asset.key.toLowerCase()] = asset;
  });

  const planetTextures = {};
  const ringTextures = {
    saturn: {}, jupiter: {}, uranus: {}, neptune: {}
  };

  const asteroidGeometries = [];
  const paleoEarthTextures = {};

  let planetModel = null;
  const missionImages = {};
  const backgroundImages = {};
  const timelineImages = {};


  for (const [key, value] of Object.entries(loadedAssets)) {
    const lowerKey = key.toLowerCase();
    const def = keyMap[lowerKey];
    if (!def) continue;

    // Asteroid geometries
    if (
      def.type === 'geometry' &&
      def.url?.startsWith('asteroid:')
    ) {
      asteroidGeometries.push({
        key: lowerKey,
        geometry: value,
      });
      continue;
    }

    // Paleo-Earth timeline scrubber frames (the 87 earthAssets entries,
    // keys like "paleo_earth_93a").
    if (
      def.type === 'texture' &&
      def.url.includes('/textures/earth_textures/') &&
      lowerKey.startsWith('paleo_earth_')
    ) {
      paleoEarthTextures[lowerKey] = value;
      continue;
    }


    // Planet surface textures
    if (
      (def.url.includes('/textures/2k_') || 
      def.url.includes('/textures/8k_') ||
      def.url.includes('/textures/paleo_earth_atlas') ||
      def.url.includes('/textures/kuiperbelt/') ||
      def.url.includes('/textures/earth_textures/')) &&
      !def.url.includes('rings')
    ) {
      planetTextures[lowerKey] = value;
    }

    // Ring textures
    else if (def.url.includes('rings') && def.type === 'texture') {
      if (lowerKey.startsWith('saturn')) {
        assignRingTexture(ringTextures.saturn, lowerKey, value);
      } else if (lowerKey.startsWith('jupiter')) {
        assignRingTexture(ringTextures.jupiter, lowerKey, value);
      } else if (lowerKey.startsWith('uranus')) {
        assignRingTexture(ringTextures.uranus, lowerKey, value);
      } else if (lowerKey.startsWith('neptune')) {
        assignRingTexture(ringTextures.neptune, lowerKey, value);
      }
    }

    // Planet model
    else if (lowerKey === 'planetmodel') {
      planetModel = value;
    }

    // Mission images
    else if (def.url.includes('/images/missions/')) {
      missionImages[lowerKey] = value;
    }

    // Background
    else if (def.url.includes('/images/milkyway')) {
      backgroundImages[lowerKey] = value;
    }

    // Timeline
    else if (def.url.includes('/images/timeline/')) {
      timelineImages[lowerKey] = value;
    }
  }

  return {
    planetTextures,
    ringTextures,
    asteroidGeometries,
    paleoEarthTextures,
    missionImages,
    backgroundImages,
    planetModel,
    timelineImages,
  };
}

// Helper to classify ring texture by suffix number
function assignRingTexture(planetObj, key, value) {
  if (key.endsWith('_1')) {
    planetObj.inner = value;
  } else if (key.endsWith('_2')) {
    planetObj.main = value;
  } else if (key.endsWith('_3')) {
    planetObj.outer = value;
  }
}
